"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Sort end events alphabetically by event name IN-PLACE for consistent
 * ordering.
 */
const sortEndEvents = endEvents => endEvents.sort((a, b) => {
    const aName = Object.keys(a)[0];
    const bName = Object.keys(b)[0];
    return aName.localeCompare(bName);
});
exports.default = sortEndEvents;
